export const FormatsData: {[k: string]: ModdedSpeciesFormatsData} = {
	bulbasaur: {
		tier: "LC",
	},
	ivysaur: {
		tier: "NFE",
	},
	venusaur: {
		randomBattleMoves: ["growth", "hiddenpowerfire", "hiddenpowerice", "leechseed", "razorleaf", "sleeppowder", "synthesis"],
		tier: "UUBL",
	},
	charmander: {
		tier: "LC",
	},
	charmeleon: {
		tier: "NFE",
	},
	charizard: {
		randomBattleMoves: ["bellydrum", "earthquake", "fireblast", "hyperbeam", "rockslide"],
		tier: "UUBL",
	},
	squirtle: {
		tier: "LC",
	},
	wartortle: {
		tier: "NFE",
	},
	blastoise: {
		randomBattleMoves: ["icebeam", "rapidspin", "rest", "sleeptalk", "surf", "toxic", "zapcannon"],
		tier: "UU",
	},
	caterpie: {
		tier: "LC",
	},
	metapod: {
		tier: "NFE",
	},
	butterfree: {
		randomBattleMoves: ["nightmare", "psychic", "sleeppowder", "stunspore", "substitute"],
		tier: "NU",
	},
	weedle: {
		tier: "LC",
	},
	kakuna: {
		tier: "NFE",
	},
	beedrill: {
		randomBattleMoves: ["agility", "hiddenpowerground", "sludgebomb", "substitute", "swordsdance"],
		tier: "NU",
	},
	pidgey: {
		tier: "LC",
	},
	pidgeotto: {
		tier: "NFE",
	},
	pidgeot: {
		randomBattleMoves: ["curse", "hiddenpowerground", "reflect", "rest", "return", "sleeptalk", "toxic", "whirlwind"],
		tier: "NU",
	},
	rattata: {
		tier: "LC",
	},
	raticate: {
		randomBattleMoves: ["irontail", "rest", "return", "sleeptalk", "superfang"],
		tier: "NU",
	},
	spearow: {
		tier: "LC",
	},
	fearow: {
		randomBattleMoves: ["doubleedge", "drillpeck", "hiddenpowerground", "rest", "sleeptalk", "substitute"],
		tier: "NU",
	},
	ekans: {
		tier: "LC",
	},
	arbok: {
		randomBattleMoves: ["curse", "earthquake", "glare", "haze", "rest", "sludgebomb"],
		tier: "NU",
	},
	pichu: {
		tier: "LC",
	},
	pikachu: {
		randomBattleMoves: ["encore", "hiddenpowerice", "substitute", "surf", "thunderbolt"],
		tier: "UU",
	},
	raichu: {
		randomBattleMoves: ["hiddenpowerice", "rest", "sleeptalk", "surf", "thunder", "thunderbolt"],
		tier: "NUBL",
	},
	sandshrew: {
		tier: "LC",
	},
	sandslash: {
		randomBattleMoves: ["earthquake", "hiddenpowerbug", "rockslide", "substitute", "swordsdance"],
		tier: "UU",
	},
	nidoranf: {
		tier: "LC",
	},
	nidorina: {
		tier: "NFE",
	},
	nidoqueen: {
		randomBattleMoves: ["earthquake", "fireblast", "icebeam", "lovelykiss", "moonlight", "thunder"],
		tier: "UU",
	},
	nidoranm: {
		tier: "LC",
	},
	nidorino: {
		tier: "NFE",
	},
	nidoking: {
		randomBattleMoves: ["earthquake", "fireblast", "icebeam", "lovelykiss", "morningsun", "thunder"],
		tier: "OU",
	},
	cleffa: {
		tier: "LC",
	},
	clefairy: {
		tier: "NFE",
	},
	clefable: {
		randomBattleMoves: ["bellydrum", "encore", "fireblast", "moonlight", "return", "shadowball"],
		tier: "UUBL",
	},
	vulpix: {
		tier: "LC",
	},
	ninetales: {
		randomBattleMoves: ["confuseray", "fireblast", "hiddenpowergrass", "hypnosis", "sunnyday"],
		tier: "NU",
	},
	igglybuff: {
		tier: "LC",
	},
	jigglypuff: {
		tier: "NFE",
	},
	wigglytuff: {
		randomBattleMoves: ["bodyslam", "charm", "curse", "doubleedge", "fireblast", "rest", "sleeptalk", "thunderwave"],
		tier: "NU",
	},
	zubat: {
		tier: "LC",
	},
	golbat: {
		tier: "NFE",
	},
	crobat: {
		randomBattleMoves: ["gigadrain", "haze", "hiddenpowerground", "rest", "whirlwind", "wingattack"],
		tier: "UU",
	},
	oddish: {
		tier: "LC",
	},
	gloom: {
		tier: "NU",
	},
	vileplume: {
		randomBattleMoves: ["hiddenpowergrass", "moonlight", "sleeppowder", "sludgebomb", "stunspore", "swordsdance"],
		tier: "UU",
	},
	bellossom: {
		randomBattleMoves: ["doubleedge", "gigadrain", "hiddenpowerfire", "leechseed", "moonlight", "sleeppowder", "stunspore"],
		tier: "UU",
	},
	paras: {
		tier: "LC",
	},
	parasect: {
		randomBattleMoves: ["bodyslam", "gigadrain", "hiddenpowerbug", "spore", "swordsdance", "synthesis"],
		tier: "NU",
	},
	venonat: {
		tier: "LC",
	},
	venomoth: {
		randomBattleMoves: ["disable", "gigadrain", "psychic", "sleeppowder", "sludgebomb", "stunspore"],
		tier: "NU",
	},
	diglett: {
		tier: "LC",
	},
	dugtrio: {
		randomBattleMoves: ["earthquake", "rockslide", "sludgebomb", "substitute", "swagger"],
		tier: "NU",
	},
	meowth: {
		tier: "LC",
	},
	persian: {
		randomBattleMoves: ["bodyslam", "hypnosis", "irontail", "rest", "return", "thunder"],
		tier: "NU",
	},
	psyduck: {
		tier: "LC",
	},
	golduck: {
		randomBattleMoves: ["crosschop", "hiddenpowerelectric", "hydropump", "hypnosis", "icebeam", "psychic", "surf"],
		tier: "NUBL",
	},
	mankey: {
		tier: "LC",
	},
	primeape: {
		randomBattleMoves: ["crosschop", "doubleedge", "hiddenpowerghost", "meditate", "rest", "rockslide", "substitute"],
		tier: "NU",
	},
	growlithe: {
		tier: "LC",
	},
	arcanine: {
		randomBattleMoves: ["bodyslam", "crunch", "extremespeed", "fireblast", "hiddenpowergrass", "rest", "sleeptalk"],
		tier: "UU",
	},
	poliwag: {
		tier: "LC",
	},
	poliwhirl: {
		tier: "NU",
	},
	poliwrath: {
		randomBattleMoves: ["bellydrum", "bodyslam", "earthquake", "lovelykiss"],
		tier: "NUBL",
	},
	politoed: {
		randomBattleMoves: ["growth", "hiddenpowerelectric", "icebeam", "lovelykiss", "rest", "sleeptalk", "surf"],
		tier: "UU",
	},
	abra: {
		tier: "LC",
	},
	kadabra: {
		tier: "UU",
	},
	alakazam: {
		randomBattleMoves: ["encore", "firepunch", "icepunch", "psychic", "recover", "thunderpunch", "thunderwave"],
		tier: "UUBL",
	},
	machop: {
		tier: "LC",
	},
	machoke: {
		tier: "NU",
	},
	machamp: {
		randomBattleMoves: ["bodyslam", "crosschop", "curse", "earthquake", "hiddenpowerghost", "rest", "rockslide", "sleeptalk"],
		tier: "OU",
	},
	bellsprout: {
		tier: "LC",
	},
	weepinbell: {
		tier: "NFE",
	},
	victreebel: {
		randomBattleMoves: ["hiddenpowerground", "razorleaf", "sleeppowder", "sludgebomb", "swordsdance", "synthesis"],
		tier: "UU",
	},
	tentacool: {
		tier: "NU",
	},
	tentacruel: {
		randomBattleMoves: ["hydropump", "sludgebomb", "substitute", "swordsdance"],
		tier: "UUBL",
	},
	geodude: {
		tier: "LC",
	},
	graveler: {
		tier: "NU",
	},
	golem: {
		randomBattleMoves: ["curse", "earthquake", "explosion", "fireblast", "rockslide"],
		tier: "OU",
	},
	ponyta: {
		tier: "LC",
	},
	rapidash: {
		randomBattleMoves: ["bodyslam", "fireblast", "hiddenpowergrass", "hypnosis", "sunnyday"],
		tier: "NU",
	},
	slowpoke: {
		tier: "NU",
	},
	slowbro: {
		randomBattleMoves: ["fireblast", "psychic", "rest", "sleeptalk", "surf", "thunderwave", "toxic"],
		tier: "UU",
	},
	slowking: {
		randomBattleMoves: ["fireblast", "psychic", "rest", "sleeptalk", "surf", "thunderwave", "toxic"],
		tier: "UU",
	},
	magnemite: {
		tier: "NU",
	},
	magneton: {
		randomBattleMoves: ["hiddenpowerice", "substitute", "thunderbolt", "thunderwave"],
		tier: "UU",
	},
	farfetchd: {
		randomBattleMoves: ["agility", "batonpass", "return", "swordsdance"],
		tier: "NU",
	},
	doduo: {
		tier: "LC",
	},
	dodrio: {
		randomBattleMoves: ["doubleedge", "drillpeck", "hiddenpowerground", "rest", "substitute"],
		tier: "UU",
	},
	seel: {
		tier: "LC",
	},
	dewgong: {
		randomBattleMoves: ["bodyslam", "encore", "icebeam", "rest", "sleeptalk", "surf", "toxic"],
		tier: "NU",
	},
	grimer: {
		tier: "LC",
	},
	muk: {
		randomBattleMoves: ["curse", "explosion", "fireblast", "hiddenpowerground", "sludgebomb"],
		tier: "UUBL",
	},
	shellder: {
		tier: "LC",
	},
	cloyster: {
		randomBattleMoves: ["explosion", "icebeam", "spikes", "surf", "toxic"],
		tier: "OU",
	},
	gastly: {
		tier: "NU",
	},
	haunter: {
		tier: "UU",
	},
	gengar: {
		randomBattleMoves: ["destinybond", "explosion", "firepunch", "hypnosis", "icepunch", "thunderbolt"],
		tier: "OU",
	},
	onix: {
		tier: "LC",
	},
	steelix: {
		randomBattleMoves: ["curse", "earthquake", "explosion", "irontail", "rest", "roar", "sleeptalk", "toxic"],
		tier: "OU",
	},
	drowzee: {
		tier: "LC",
	},
	hypno: {
		randomBattleMoves: ["hypnosis", "lightscreen", "psychic", "reflect", "seismictoss", "thunderwave"],
		tier: "UU",
	},
	krabby: {
		tier: "LC",
	},
	kingler: {
		randomBattleMoves: ["hiddenpowerground", "rest", "return", "surf", "swordsdance"],
		tier: "NU",
	},
	voltorb: {
		tier: "NU",
	},
	electrode: {
		randomBattleMoves: ["explosion", "hiddenpowerice", "lightscreen", "reflect", "thunderbolt", "thunderwave"],
		tier: "UU",
	},
	exeggcute: {
		tier: "NU",
	},
	exeggutor: {
		randomBattleMoves: ["explosion", "gigadrain", "hiddenpowerfire", "psychic", "sleeppowder", "stunspore", "synthesis"],
		tier: "OU",
	},
	cubone: {
		tier: "NU",
	},
	marowak: {
		randomBattleMoves: ["earthquake", "hiddenpowerbug", "rockslide", "swordsdance"],
		tier: "OU",
	},
	tyrogue: {
		tier: "LC",
	},
	hitmonlee: {
		randomBattleMoves: ["bodyslam", "hiddenpowerghost", "highjumpkick", "meditate", "rest"],
		tier: "NU",
	},
	hitmonchan: {
		randomBattleMoves: ["bodyslam", "counter", "curse", "hiddenpowerghost", "highjumpkick"],
		tier: "NU",
	},
	hitmontop: {
		randomBattleMoves: ["curse", "hiddenpowerghost", "highjumpkick", "rest", "sleeptalk"],
		tier: "NU",
	},
	lickitung: {
		randomBattleMoves: ["bodyslam", "earthquake", "fireblast", "rest", "sleeptalk", "swordsdance"],
		tier: "NU",
	},
	koffing: {
		tier: "LC",
	},
	weezing: {
		randomBattleMoves: ["explosion", "fireblast", "hiddenpowergrass", "painsplit", "sludgebomb", "thunder"],
		tier: "NU",
	},
	rhyhorn: {
		tier: "LC",
	},
	rhydon: {
		randomBattleMoves: ["curse", "earthquake", "fireblast", "rest", "roar", "rockslide", "sleeptalk", "zapcannon"],
		tier: "OU",
	},
	chansey: {
		tier: "UU",
	},
	blissey: {
		randomBattleMoves: ["flamethrower", "healbell", "icebeam", "present", "sing", "softboiled", "toxic"],
		tier: "OU",
	},
	tangela: {
		randomBattleMoves: ["gigadrain", "growth", "hiddenpowerice", "sleeppowder", "synthesis"],
		tier: "NU",
	},
	kangaskhan: {
		randomBattleMoves: ["bodyslam", "curse", "earthquake", "rest", "return", "roar", "sleeptalk"],
		tier: "UUBL",
	},
	horsea: {
		tier: "LC",
	},
	seadra: {
		tier: "NU",
	},
	kingdra: {
		randomBattleMoves: ["dragonbreath", "hiddenpowerelectric", "icebeam", "rest", "sleeptalk", "surf"],
		tier: "UUBL",
	},
	goldeen: {
		tier: "LC",
	},
	seaking: {
		randomBattleMoves: ["agility", "return", "substitute", "surf", "swordsdance"],
		tier: "NU",
	},
	staryu: {
		tier: "LC",
	},
	starmie: {
		randomBattleMoves: ["psychic", "rapidspin", "recover", "surf", "thunderbolt", "thunderwave"],
		tier: "OU",
	},
	mrmime: {
		randomBattleMoves: ["encore", "firepunch", "hypnosis", "icepunch", "psychic", "thief", "thunderbolt", "thunderwave"],
		tier: "UU",
	},
	scyther: {
		randomBattleMoves: ["batonpass", "hiddenpowerbug", "hiddenpowerground", "swordsdance", "wingattack"],
		tier: "UU",
	},
	scizor: {
		randomBattleMoves: ["agility", "batonpass", "hiddenpowerbug", "return", "swordsdance"],
		tier: "UUBL",
	},
	smoochum: {
		tier: "LC",
	},
	jynx: {
		randomBattleMoves: ["icebeam", "lovelykiss", "nightmare", "psychic", "substitute", "thief"],
		tier: "OU",
	},
	elekid: {
		tier: "NU",
	},
	electabuzz: {
		randomBattleMoves: ["crosschop", "icepunch", "psychic", "pursuit", "thunder", "thunderbolt"],
		tier: "UU",
	},
	magby: {
		tier: "LC",
	},
	magmar: {
		randomBattleMoves: ["crosschop", "fireblast", "hiddenpowerground", "sunnyday", "thief", "thunderpunch"],
		tier: "NU",
	},
	pinsir: {
		randomBattleMoves: ["bodyslam", "doubleedge", "hiddenpowerbug", "rest", "submission", "swordsdance"],
		tier: "UU",
	},
	tauros: {
		randomBattleMoves: ["curse", "doubleedge", "earthquake", "rest", "return", "sleeptalk"],
		tier: "UUBL",
	},
	magikarp: {
		tier: "LC",
	},
	gyarados: {
		randomBattleMoves: ["bodyslam", "doubleedge", "hiddenpowerflying", "hydropump", "rest", "sleeptalk", "thunder"],
		tier: "UU",
	},
	lapras: {
		randomBattleMoves: ["icebeam", "rest", "sing", "sleeptalk", "surf", "thunder", "thunderbolt", "toxic"],
		tier: "UUBL",
	},
	ditto: {
		randomBattleMoves: ["transform"],
		tier: "NU",
	},
	eevee: {
		tier: "LC",
	},
	vaporeon: {
		randomBattleMoves: ["growth", "hiddenpowerelectric", "icebeam", "rest", "sleeptalk", "surf"],
		tier: "OU",
	},
	jolteon: {
		randomBattleMoves: ["batonpass", "growth", "hiddenpowerice", "hiddenpowerwater", "substitute", "thunderbolt", "thunderwave"],
		tier: "UUBL",
	},
	flareon: {
		randomBattleMoves: ["batonpass", "doubleedge", "fireblast", "growth", "hiddenpowergrass", "zapcannon"],
		tier: "NU",
	},
	espeon: {
		randomBattleMoves: ["batonpass", "bite", "growth", "hiddenpowerfire", "morningsun", "psychic", "substitute"],
		tier: "UUBL",
	},
	umbreon: {
		randomBattleMoves: ["batonpass", "growth", "hiddenpowerdark", "meanlook", "moonlight"],
		tier: "OU",
	},
	porygon: {
		tier: "NU",
	},
	porygon2: {
		randomBattleMoves: ["curse", "doubleedge", "icebeam", "recover", "return", "thunderbolt", "thunderwave"],
		tier: "UUBL",
	},
	omanyte: {
		tier: "LC",
	},
	omastar: {
		randomBattleMoves: ["hiddenpowerelectric", "icebeam", "rest", "sleeptalk", "surf"],
		tier: "UU",
	},
	kabuto: {
		tier: "LC",
	},
	kabutops: {
		randomBattleMoves: ["ancientpower", "hiddenpowerground", "return", "submission", "surf", "swordsdance"],
		tier: "UU",
	},
	aerodactyl: {
		randomBattleMoves: ["ancientpower", "curse", "earthquake", "hiddenpowerflying", "reflect", "whirlwind"],
		tier: "UUBL",
	},
	snorlax: {
		randomBattleMoves: ["curse", "doubleedge", "earthquake", "fireblast", "lovelykiss", "rest", "return", "sleeptalk"],
		tier: "OU",
	},
	articuno: {
		randomBattleMoves: ["hiddenpowerelectric", "icebeam", "rest", "sleeptalk", "toxic"],
		tier: "UUBL",
	},
	zapdos: {
		randomBattleMoves: ["hiddenpowerice", "rest", "roar", "sleeptalk", "thunder", "thunderwave"],
		tier: "OU",
	},
	moltres: {
		randomBattleMoves: ["fireblast", "hiddenpowergrass", "rest", "sleeptalk", "sunnyday"],
		tier: "UUBL",
	},
	dratini: {
		tier: "LC",
	},
	dragonair: {
		tier: "NU",
	},
	dragonite: {
		randomBattleMoves: ["haze", "hiddenpowerflying", "icebeam", "lightscreen", "reflect", "rest", "thunder"],
		tier: "UUBL",
	},
	mewtwo: {
		randomBattleMoves: ["fireblast", "icebeam", "psychic", "recover", "thunderbolt", "thunderwave"],
		tier: "Uber",
	},
	mew: {
		randomBattleMoves: ["earthquake", "explosion", "psychic", "shadowball", "softboiled", "submission", "swordsdance"],
		tier: "Uber",
	},
	chikorita: {
		tier: "LC",
	},
	bayleef: {
		tier: "NU",
	},
	meganium: {
		randomBattleMoves: ["hiddenpowerfire", "leechseed", "lightscreen", "razorleaf", "reflect", "synthesis"],
		tier: "UUBL",
	},
	cyndaquil: {
		tier: "LC",
	},
	quilava: {
		tier: "NFE",
	},
	typhlosion: {
		randomBattleMoves: ["earthquake", "fireblast", "rest", "sleeptalk", "thunderpunch"],
		tier: "UUBL",
	},
	totodile: {
		tier: "LC",
	},
	croconaw: {
		tier: "NFE",
	},
	feraligatr: {
		randomBattleMoves: ["crunch", "earthquake", "icebeam", "rest", "rockslide", "sleeptalk", "surf"],
		tier: "NUBL",
	},
	sentret: {
		tier: "LC",
	},
	furret: {
		randomBattleMoves: ["curse", "doubleedge", "rest", "shadowball", "sleeptalk", "surf"],
		tier: "NU",
	},
	hoothoot: {
		tier: "LC",
	},
	noctowl: {
		randomBattleMoves: ["hypnosis", "nightshade", "reflect", "thief", "toxic", "whirlwind"],
		tier: "NU",
	},
	ledyba: {
		tier: "LC",
	},
	ledian: {
		randomBattleMoves: ["agility", "barrier", "batonpass", "lightscreen"],
		tier: "NU",
	},
	spinarak: {
		tier: "LC",
	},
	ariados: {
		randomBattleMoves: ["batonpass", "curse", "sludgebomb", "spiderweb"],
		tier: "NU",
	},
	chinchou: {
		tier: "NU",
	},
	lanturn: {
		randomBattleMoves: ["icebeam", "raindance", "rest", "sleeptalk", "surf", "thunder"],
		tier: "UU",
	},
	togepi: {
		tier: "LC",
	},
	togetic: {
		randomBattleMoves: ["fireblast", "solarbeam", "sunnyday", "zapcannon"],
		tier: "NU",
	},
	natu: {
		tier: "LC",
	},
	xatu: {
		randomBattleMoves: ["drillpeck", "haze", "hiddenpowergrass", "hiddenpowerwater", "psychic", "rest", "sleeptalk", "thief"],
		tier: "NU",
	},
	mareep: {
		tier: "LC",
	},
	flaaffy: {
		tier: "NU",
	},
	ampharos: {
		randomBattleMoves: ["firepunch", "hiddenpowerice", "lightscreen", "reflect", "rest", "sleeptalk", "thunderbolt", "thunderwave"],
		tier: "UU",
	},
	marill: {
		tier: "LC",
	},
	azumarill: {
		randomBattleMoves: ["perishsong", "rest", "surf", "whirlpool"],
		tier: "NU",
	},
	sudowoodo: {
		randomBattleMoves: ["curse", "earthquake", "rest", "rockslide", "selfdestruct", "sleeptalk"],
		tier: "NU",
	},
	hoppip: {
		tier: "LC",
	},
	skiploom: {
		tier: "NFE",
	},
	jumpluff: {
		randomBattleMoves: ["gigadrain", "hiddenpowerice", "hiddenpowerwater", "leechseed", "sleeppowder", "stunspore"],
		tier: "UU",
	},
	aipom: {
		randomBattleMoves: ["agility", "batonpass", "curse", "return", "shadowball"],
		tier: "NU",
	},
	sunkern: {
		tier: "LC",
	},
	sunflora: {
		randomBattleMoves: ["growth", "hiddenpowerfire", "hiddenpowerwater", "razorleaf", "synthesis"],
		tier: "NU",
	},
	yanma: {
		randomBattleMoves: ["gigadrain", "hiddenpowerbug", "hiddenpowerflying", "return", "screech", "thief"],
		tier: "NU",
	},
	wooper: {
		tier: "LC",
	},
	quagsire: {
		randomBattleMoves: ["bellydrum", "bodyslam", "earthquake", "rest", "surf"],
		tier: "UU",
	},
	murkrow: {
		randomBattleMoves: ["drillpeck", "haze", "hiddenpowerdark", "hiddenpowerfire", "pursuit", "thief", "toxic"],
		tier: "NU",
	},
	misdreavus: {
		randomBattleMoves: ["meanlook", "painsplit", "perishsong", "psychic", "shadowball", "thief", "thunderbolt"],
		tier: "OU",
	},
	unown: {
		randomBattleMoves: ["hiddenpowerpsychic"],
		tier: "NU",
	},
	wobbuffet: {
		randomBattleMoves: ["counter", "mimic", "mirrorcoat", "safeguard"],
		tier: "NU",
	},
	girafarig: {
		randomBattleMoves: ["crunch", "curse", "earthquake", "psychic", "rest", "return", "thunderbolt"],
		tier: "UU",
	},
	pineco: {
		tier: "NU",
	},
	forretress: {
		randomBattleMoves: ["doubleedge", "explosion", "hiddenpowerbug", "rapidspin", "reflect", "spikes", "toxic"],
		tier: "OU",
	},
	dunsparce: {
		randomBattleMoves: ["curse", "flamethrower", "rest", "return", "sleeptalk", "thunder", "thunderbolt"],
		tier: "NU",
	},
	gligar: {
		randomBattleMoves: ["counter", "earthquake", "hiddenpowerflying", "return", "screech", "sludgebomb", "thief"],
		tier: "UU",
	},
	snubbull: {
		tier: "LC",
	},
	granbull: {
		randomBattleMoves: ["curse", "healbell", "hiddenpowerground", "lovelykiss", "rest", "return", "sleeptalk"],
		tier: "UU",
	},
	qwilfish: {
		randomBattleMoves: ["curse", "haze", "hydropump", "sludgebomb", "spikes"],
		tier: "UU",
	},
	shuckle: {
		randomBattleMoves: ["defensecurl", "rest", "rollout", "toxic"],
		tier: "NU",
	},
	heracross: {
		randomBattleMoves: ["curse", "earthquake", "megahorn", "rest", "seismictoss", "sleeptalk"],
		tier: "OU",
	},
	sneasel: {
		randomBattleMoves: ["icebeam", "moonlight", "return", "screech", "shadowball", "thief"],
		tier: "NU",
	},
	teddiursa: {
		tier: "LC",
	},
	ursaring: {
		randomBattleMoves: ["curse", "earthquake", "rest", "return", "roar", "sleeptalk"],
		tier: "UUBL",
	},
	slugma: {
		tier: "LC",
	},
	magcargo: {
		randomBattleMoves: ["curse", "earthquake", "fireblast", "rest", "rockslide", "sleeptalk"],
		tier: "NU",
	},
	swinub: {
		tier: "LC",
	},
	piloswine: {
		randomBattleMoves: ["ancientpower", "bodyslam", "curse", "earthquake", "icebeam", "rest", "sleeptalk"],
		tier: "UU",
	},
	corsola: {
		randomBattleMoves: ["curse", "recover", "rockslide", "surf", "toxic"],
		tier: "NU",
	},
	remoraid: {
		tier: "LC",
	},
	octillery: {
		randomBattleMoves: ["flamethrower", "hiddenpowerelectric", "icebeam", "rest", "sleeptalk", "surf"],
		tier: "NU",
	},
	delibird: {
		randomBattleMoves: ["hiddenpowerflying", "icebeam", "present", "spikes", "thief"],
		tier: "NU",
	},
	mantine: {
		randomBattleMoves: ["haze", "hiddenpowerelectric", "icebeam", "rest", "sleeptalk", "surf", "toxic"],
		tier: "NU",
	},
	skarmory: {
		randomBattleMoves: ["curse", "drillpeck", "rest", "sleeptalk", "toxic"],
		tier: "OU",
	},
	houndour: {
		tier: "NU",
	},
	houndoom: {
		randomBattleMoves: ["crunch", "fireblast", "pursuit", "solarbeam", "sunnyday"],
		tier: "UUBL",
	},
	phanpy: {
		tier: "LC",
	},
	donphan: {
		randomBattleMoves: ["ancientpower", "curse", "earthquake", "hiddenpowerbug", "rapidspin", "rest", "roar", "sleeptalk"],
		tier: "UUBL",
	},
	stantler: {
		randomBattleMoves: ["confuseray", "curse", "earthquake", "rest", "return", "sleeptalk"],
		tier: "NU",
	},
	smeargle: {
		randomBattleMoves: ["agility", "batonpass", "spikes", "spore"],
		tier: "UUBL",
	},
	miltank: {
		randomBattleMoves: ["bodyslam", "curse", "earthquake", "healbell", "milkdrink"],
		tier: "OU",
	},
	raikou: {
		randomBattleMoves: ["crunch", "hiddenpowerice", "hiddenpowerwater", "reflect", "rest", "roar", "sleeptalk", "thunder", "thunderbolt"],
		tier: "OU",
	},
	entei: {
		randomBattleMoves: ["fireblast", "hiddenpowerrock", "return", "solarbeam", "sunnyday"],
		tier: "UUBL",
	},
	suicune: {
		randomBattleMoves: ["hiddenpowerelectric", "icebeam", "rest", "roar", "sleeptalk", "surf", "toxic"],
		tier: "OU",
	},
	larvitar: {
		tier: "LC",
	},
	pupitar: {
		tier: "NU",
	},
	tyranitar: {
		randomBattleMoves: ["crunch", "curse", "earthquake", "fireblast", "pursuit", "rest", "rockslide", "screech", "surf"],
		tier: "OU",
	},
	lugia: {
		randomBattleMoves: ["aeroblast", "curse", "earthquake", "icebeam", "recover", "whirlwind"],
		tier: "Uber",
	},
	hooh: {
		randomBattleMoves: ["curse", "earthquake", "hiddenpowerflying", "recover", "sacredfire", "thunder", "thunderbolt"],
		tier: "Uber",
	},
	celebi: {
		randomBattleMoves: ["hiddenpowergrass", "healbell", "leechseed", "psychic", "recover", "toxic"],
		tier: "Uber",
	},
};
